import {
  Button,
  Card,
  Spinner,
} from "react-bootstrap";
import { FaExchangeAlt } from "react-icons/fa";
import {
  IoReloadOutline,
  IoSparklesOutline,
} from "react-icons/io5";
import Typewriter from "typewriter-effect";
import GradientText from "../../components/Logo";
import PieChartWithLegend from "../../components/shared/charts/PieChart";
import DonutScoreChart from "../../components/shared/charts/DonutScoreChart";
import { useHistory } from "react-router-dom";
import useWallet from "../../hooks/useWallet";
import { useEffect, useState } from "react";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { BiAnalyse } from "react-icons/bi";
import LoadingBar from "react-top-loading-bar";
import LoadingQueue from "../../components/wallet/LoadingQueue";
import { isMobile } from "react-device-detect";
import { WalletInsightResponseB3 } from "../../@types/WalletB3";
import { MdOutlineFileUpload } from "react-icons/md";
import { GiOpenTreasureChest, GiReceiveMoney } from "react-icons/gi";
import StockProfileCard from "../../components/walletb3/stocks/StockProfileCard";
import FundProfileCard from "../../components/walletb3/funds/FundProfileCard";

export default function WalletB3() {
  const [walletData, setWalletData] = useState<WalletInsightResponseB3 | null>(
    null
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { push } = useHistory();
  const { getInsightsB3, dispatchToQueueB3 } = useWallet();

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const response = await getInsightsB3();

      if (response.status === 200) {
        setWalletData(response.data);

        let interval: any = setInterval(async () => {
          const newResponse = await getInsightsB3();

          if (newResponse.status === 200 && newResponse.data.additional.is_present) {
            setWalletData(newResponse.data);
            return clearInterval(interval);
          }
        }, 3500);

      } else if (response.status === 404) {
        push('/setup-wallet-b3');
      }

      setIsLoading(false);
    }

    fetchData();
  }, []);


  async function handleUpdateData() {
    setIsLoading(true);
    setWalletData(null);

    await dispatchToQueueB3();

    const interval: NodeJS.Timeout = setInterval(async () => {
      const walletDataResponse = await getInsightsB3();

      if (walletDataResponse.status === 200) {
        setWalletData(walletDataResponse.data);
        setIsLoading(false);


        let innerInterval: any = setInterval(async () => {
          const newResponse = await getInsightsB3();

          if (newResponse.status === 200 && newResponse.data.additional.is_present) {
            setWalletData(newResponse.data);
            return clearInterval(innerInterval);
          }
        }, 3500);

        return clearInterval(interval);
      } else if (walletDataResponse.status === 404) {
        push('/setup-wallet-b3');
      }
    }, 2500);
  }

  const iconSize = 22;

  if (isLoading) {
    return <LoadingState />;
  }

  if (walletData) {
    return (
      <div className="pd-t-20 pd-b-20">
        <div className="row">
          <div className="col-lg-8">
            <div className="card card-dashboard-four materialized-card">
              <div className="card-header">
                <h4>
                  <GradientText text={"Lucy AI"} />
                  <IoSparklesOutline
                    style={{ color: "var(--primary-blue)" }}
                    size={25}
                  />
                </h4>
              </div>
              <div id="wallet-step-2" className="card-body">
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter.typeString(
                      walletData.insights.wallet.ai_insight
                    );

                    typewriter.start();
                  }}
                  options={{
                    delay: 1,
                    cursorClassName: "d-none",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 mg-t-20 mg-lg-t-0">
            <div className="row row-sm">
              {/* Scores Carteira */}
              <div className="col-md-6 col-lg-12 mg-b-20 mg-md-b-0 mg-lg-b-20">
                <div id="wallet-step-3" className="card card-dashboard-five materialized-card">
                  <div className="card-header">
                    <h6 className="tx-16 tx-primary tx-semibold">
                      Avaliação da carteira
                    </h6>
                    <span className="card-text">
                      Nosso modelo de IA avaliou sua carteira e determinou as
                      seguintes pontuações e sentimentos.
                    </span>
                  </div>
                  <div className="card-body">
                    <div className="d-flex justify-content-center">
                      <DonutScoreChart
                        score={walletData.insights.wallet.ai_score}
                      />
                    </div>

                    {SentimentListItem(walletData.insights.wallet.ai_sentiment)}
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div id="wallet-step-4" className="card card-dashboard-pageviews materialized-card">
                  <div className="card-header">
                    <div className="d-flex">
                      <h6 className="tx-16 tx-primary tx-semibold">
                        Minha carteira
                      </h6>
                    </div>
                    <p className="card-text">
                      Confira alguns detalhes importantes da sua carteira e
                      visualize um gráfico de diversificação de ativos.
                    </p>
                  </div>
                  {/* card-header */}
                  <div className="card-body">
                    {walletData.diversification.total > 0 ? (
                      <PieChartWithLegend
                        data={[
                          {
                            name: "Ações BR",
                            value: walletData.diversification.brazilian_stock,
                            color: "#f2f542",
                          },
                          {
                            name: "BRDs",
                            value: walletData.diversification.brds,
                            color: "#f58442",
                          },
                          {
                            name: "ETFs",
                            value: walletData.diversification.etfs,
                            color: "#da42f5",
                          },
                          {
                            name: "Renda fixa",
                            value: walletData.diversification.fixed_income,
                            color: "#42f542",
                          },
                          {
                            name: "Fundos",
                            value: walletData.diversification.funds,
                            color: "#4269f5",
                          },
                          {
                            name: "Tesouro direto",
                            value: walletData.diversification.tesouro_direto,
                            color: "#f54242",
                          },
                        ]}
                        height={340}
                        label="Ativos"
                        labelTotal={walletData.diversification.total}
                      />
                    ) : (
                      <></>
                    )}

                    {getToleranceListItem(walletData.wallet_details.investor.tolerance)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="separator mg-t-20 mg-b-20">
          Última atualização dos dados em{" "}
          {moment(walletData.updated_at).format("DD/MM/YYYY [ás] HH:mm")}
        </div>

        {!isMobile ? <Card className="mg-b-20  materialized-card">
          <Card.Body
            className="d-flex justify-content-center flex-wrap"
            style={{ gap: 20 }}
          >
            <Button
              className="rounded-button"
              onClick={() => handleUpdateData()}
            >
              Atualizar análise <IoReloadOutline size={iconSize} />
            </Button>
            <Button
              className="rounded-button"
              onClick={() => push('/setup-wallet-b3')}
            >
              Enviar nova posição <MdOutlineFileUpload size={iconSize} />
            </Button>
          </Card.Body>
        </Card> : <></>}
        {isMobile ? <Card className="mg-b-20  materialized-card">
          <Card.Body
            className="d-flex justify-content-center flex-wrap"
            style={{ gap: 20 }}
          >
            <Button
              className="rounded-button"
              onClick={() => handleUpdateData()}
            >
              Atualizar análise <IoReloadOutline size={iconSize} />
            </Button>
            <Button
              className="rounded-button"
              onClick={() => push('/setup-wallet-b3')}
            >
              Enviar nova posição <MdOutlineFileUpload size={iconSize} />
            </Button>
          </Card.Body>
        </Card> : <></>}

        {!walletData.additional.is_present && <div className="content-wrapper w-100">
          <div className="row">
            <div className="col-lg-12">
              <div className="card mg-b-20" style={{ borderRadius: 10 }}>
                <div className="card-body">
                  <h3>Pensando sobre ativos...</h3>
                  <Skeleton count={5} />
                </div>
              </div>
            </div>
          </div>
        </div>
        }



        <div className="content-wrapper w-100">
          <div className="row">
            <div className="col-lg-12">
              <div className="card mg-b-20" style={{ borderRadius: 10 }}>
                <div className="card-body">
                  <div className="tab-content border-0 tab-content-basic animated fadeInDown">
                    <div
                      className="tab-pane fade show active"
                      id="open-tickets"
                      role="tabpanel"
                      aria-labelledby="open-tickets"
                    >
                      {
                        walletData.diversification.brazilian_stock > 0 &&
                        <p className="tx-16">
                          <strong>Ações brasileiras:</strong> R$ {walletData.wallet_details.brazilian_stocks.details.total_investment}
                        </p>
                      }

                      {walletData.wallet_details.brazilian_stocks.products.map((product: any) => {
                        return <StockProfileCard stockIconColor="#f2f542" product={product} isAdditionalDataPresent={walletData.additional.is_present} />;
                      })}

                      {
                        walletData.diversification.brds > 0 &&
                        <p className="tx-16">
                          <strong>BRDs:</strong> R$ {walletData.wallet_details.brds.details.total_investment}
                        </p>
                      }

                      {walletData.wallet_details.brds.products.map((product: any) => {
                        return <StockProfileCard stockIconColor="#f58442" product={product} isAdditionalDataPresent={walletData.additional.is_present} />
                      })}

                      {
                        walletData.diversification.etfs > 0 &&
                        <p className="tx-16">
                          <strong>ETFs:</strong> R$ {walletData.wallet_details.etfs.details.total_investment}
                        </p>
                      }

                      {walletData.wallet_details.etfs.products.map((product: any) => {
                        return (
                          <div
                            className="tickets-card row cursor-default"
                          >
                            <div className="tickets-details col-lg-6">
                              <div className="wrapper">
                                <div
                                  className="img-xs rounded-circle"
                                >
                                  <FaExchangeAlt size={20} color="#da42f5" />
                                </div>
                                <h5>{product.name}</h5>
                              </div>

                              <div className="row flex-column">
                                <div className="col-12">
                                  Ticker:{" "}
                                  <div
                                    className="badge badge-pill badge-secondary"
                                    style={{ marginLeft: 0 }}
                                  >
                                    {product.ticker}
                                  </div>
                                </div>

                                <div className="col-12">
                                  Quantidade:{" "}
                                  <div
                                    className="badge badge-pill badge-secondary"
                                    style={{ marginLeft: 0 }}
                                  >
                                    {product.qnt}
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        );
                      })}

                      {
                        walletData.diversification.fixed_income > 0 &&
                        <p className="tx-16">
                          <strong>Renda fixa:</strong> R$ {walletData.wallet_details.fixed_income.details.total_investment_mtm}
                        </p>
                      }

                      {walletData.wallet_details.fixed_income.products.map((product: any) => {
                        return (
                          <div
                            className="tickets-card row cursor-default"
                          >
                            <div className="tickets-details col-lg-6">
                              <div className="wrapper">
                                <div
                                  className="img-xs rounded-circle"
                                >
                                  <GiReceiveMoney size={20} color="#42f542" />
                                </div>
                                <h5>{product.name}</h5>
                              </div>

                              <div className="row flex-column">
                                <div className="col-12">
                                  Code:{" "}
                                  <div
                                    className="badge badge-pill badge-secondary"
                                    style={{ marginLeft: 0 }}
                                  >
                                    {product.ticker}
                                  </div>
                                </div>

                                <div className="col-12">
                                  Quantidade:{" "}
                                  <div
                                    className="badge badge-pill badge-secondary"
                                    style={{ marginLeft: 0 }}
                                  >
                                    {product.qnt}
                                  </div>
                                </div>

                                <div className="col-12">
                                  Vencimento:{" "}
                                  <div
                                    className="badge badge-pill badge-secondary"
                                    style={{ marginLeft: 0 }}
                                  >
                                    {product.shelf_date}
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        );
                      })}

                      {
                        walletData.diversification.funds > 0 &&
                        <p className="tx-16">
                          <strong>Fundos:</strong> R$ {walletData.wallet_details.funds.details.total_investment}
                        </p>
                      }


                      {walletData.wallet_details.funds.products.map((product: any) => {
                        return <FundProfileCard product={product} isAdditionalDataPresent={walletData.additional.is_present} />;
                      })}

                      {
                        walletData.diversification.tesouro_direto > 0 &&
                        <p className="tx-16">
                          <strong>Tesouro direto:</strong> R$ {walletData.wallet_details.tesouro_direto.details.total_investment}
                        </p>
                      }

                      {walletData.wallet_details.tesouro_direto.products.map((product: any) => {
                        return (
                          <div
                            className="tickets-card row cursor-default"
                          >
                            <div className="tickets-details col-lg-6">
                              <div className="wrapper">
                                <div
                                  className="img-xs rounded-circle"
                                >
                                  <GiOpenTreasureChest size={20} color="#f54242" />
                                </div>
                                <h5>{product.name}</h5>
                              </div>

                              <div className="row flex-column">
                                <div className="col-12">
                                  Indexador:{" "}
                                  <div
                                    className="badge badge-pill badge-secondary"
                                    style={{ marginLeft: 0 }}
                                  >
                                    {product.index}
                                  </div>
                                </div>

                                <div className="col-12">
                                  Vencimento:{" "}
                                  <div
                                    className="badge badge-pill badge-secondary"
                                    style={{ marginLeft: 0 }}
                                  >
                                    {product.shelf_date}
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="pd-t-20 pd-b-20">
        <Card className="materialized-card">
          <Card.Body>
            <div className="text-center">
              <BiAnalyse color="var(--primary-blue)" size={50} />
              <h1>Atualizar dados</h1>
              <p className="tx-16">
                Nosso modelo de I.A precisa se atualizar com os dados da sua
                carteira, toque no botão abaixo para iniciar.
              </p>
              <Button
                onClick={() => handleUpdateData()}
                className="rounded-button"
              >
                Atualizar dados
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

function LoadingState() {
  const [progressBar, setProgressBar] = useState<number>(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (progressBar < 95) {
        setProgressBar((val) => val + 5);
      }
    }, 250);

    return () => clearInterval(intervalId);
  }, [progressBar]);

  return (
    <div className="pd-t-20 pd-b-20">
      <LoadingBar
        color={"#596EFD"}
        height={3}
        shadow={true}
        loaderSpeed={3500}
        progress={progressBar}
      />
      <div className="row">
        <div className="col-lg-8">{<LoadingQueue show />}</div>
        <div className="col-lg-4 mg-t-20 mg-lg-t-0">
          <div className="row row-sm">
            {/* Scores Carteira */}
            <div className="col-md-6 col-lg-12 mg-b-20 mg-md-b-0 mg-lg-b-20">
              <div className="card card-dashboard-five materialized-card h-100">
                <div className="card-header">
                  <h6 className="tx-16 tx-primary tx-semibold">
                    Avaliação da carteira
                  </h6>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-center">
                    <Spinner animation="border" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-12">
              <div className="card card-dashboard-pageviews materialized-card h-100">
                <div className="card-header">
                  <div className="d-flex">
                    <h6 className="tx-16 tx-primary tx-semibold">
                      Minha carteira
                    </h6>
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-center">
                    <Spinner animation="border" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content-wrapper w-100 mg-t-20">
        <div className="row">
          <div className="col-md-12">
            <div className="card materialized-card">
              <div className="card-body">
                <div className="d-flex">
                  <div className="wrapper">
                    <h4 className="tx-18 tx-primary tx-semibold">
                      Meus ativos
                    </h4>
                  </div>
                  <div className="wrapper"></div>
                </div>
                <div className="row project-list-showcase">
                  {[0, 1, 2].map((item) => {
                    return (
                      <div className="col-12 col-md-6 col-lg-4 project-grid">
                        <div
                          className="project-grid-inner materialized-card h-100"
                          key={item}
                        >
                          <div className="d-flex align-items-start pd-b-20">
                            <div className="d-flex">
                              <Skeleton
                                width={30}
                                height={30}
                                borderRadius={50}
                              />
                            </div>
                          </div>
                          <Skeleton count={3} />

                          <br />
                          <Skeleton count={2} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function SentimentListItem(sentiment: number) {
  let sentimentColor = "";
  let sentimentText = "";

  switch (sentiment) {
    case 0:
      sentimentColor = "tx-danger";
      sentimentText = "CUIDADO";
      break;
    case 1:
      sentimentColor = "tx-warning";
      sentimentText = "ATENÇÃO";
      break;
    case 2:
      sentimentColor = "tx-secondary";
      sentimentText = "NEUTRO";
      break;
    case 3:
      sentimentColor = "tx-success";
      sentimentText = "EXCELENTE";
      break;
    default:
      sentimentColor = "tx-secondary";
      sentimentText = "NEUTRO";
  }

  return (
    <div className="az-list-item">
      <div>
        <h6>Sentimento da IA</h6>
        <span>Ao avaliar sua carteira.</span>
      </div>
      <div>
        <h6 className={sentimentColor}>{sentimentText}</h6>
      </div>
    </div>
  );
}

function getToleranceListItem(tolerance: string) {
  let color = "";
  let text = "";

  switch (tolerance) {
    case "low":
      color = "danger";
      text = "BAIXA";
      break;
    case "high":
      color = "success";
      text = "ALTA";
      break;
    default:
      color = "secondary";
      text = "?";
  }

  return (
    <div className="az-list-item mg-t-20">
      <div>
        <h6>Tolerância</h6>
        <span>Se refere ao quanto você suporta perder.</span>
      </div>
      <div>
        <h6 className={`tx-${color}`}>{text}</h6>
      </div>
    </div>
  );
}
